export const locale = {
    lang: 'es',
    data: {
        "PAGES": {
            "HOME": {
                "TITLE": "Inicio"
            },
            "AUTHENTICATION": {
                "LOGIN": {
                    "INTRO": {
                        "TITLE": "Bienvenido a SiGE",
                        "DESCRIPTION": "Col. Salta Argentina"
                    },
                    "FORM": {
                        "TITLE": "Ingrese a su cuenta",
                        "DESCRIPTION": "Ingrese usuario y contraseña"
                    }
                }
            },
            "MANAGEMENT": {
                "GROUP_NAME": "Administración",
                "USERS": "Usuarios",
                "STUDENTS": "Alumnos",
                "EMPLOYEES": "Personal",
                "SUBJECTS": "Materias",
                "CURRICULA": "Planes de Estudios",
                "SCHOOL_YEARS": "Años Lectivos",
                "SCHOOL_SCHEDULE": "Horario Escolar",
                "DIVISIONS": "Divisiones",
                "PROFESSIONAL_CONCEPT": "Concepto Docente",
                "DIVISION_SCHEDULE": "Horario por División",
                "TEACHERS": "Docentes",
                "SCHOOLDATA": "Datos del colegio",
                "NEWS": "Noticias",
                "EXAM_CALLS": "Exámenes",
                "EXAM_BOARDS": "Mesas de exámenes",
                "ACTOS": "Actos"
            },

            "SECURITY": {
                "GROUP_NAME": "Seguridad",
                "ROLESANDPERMISSIONS": "Roles y permisos"
            },
            "NEWS": {
                "GROUP_NAME": "Noticias",
                "NEWS": "Administrador de Noticias"
            },
            "CONFIGURATION": {
                "GROUP_NAME": "Configuración",
                "DIVISION_COLOR_CONFIG": "Configurar Divisiones",
                "INDEX_CARD_CONFIGURATION": "Configuración de Fichero",
            }
        },
        "FIELDS": {
            "ID": "ID",
            "ALIAS": "Alias",
            "USERNAME": "Nombre de usuario",
            "PASSWORD": "Contraseña",
            "CONFIRM_PASSWORD": "Confirmar contraseña",
            "EMAIL": "Email",
            "EMAIL_ALUMNO": "Email del alumno",
            "EMAIL_TUTOR": "Email del alumno",
            "FIRST_NAME": "Nombre/s",
            "FIRST_NAME_ALUMNO": "Nombre/s del alumno",
            "FIRST_NAME_TUTOR": "Nombre/s del tutor",
            "LAST_NAME": "Apellido/s",
            "LAST_NAME_ALUMNO": "Apellido/s del alumno",
            "LAST_NAME_TUTOR": "Apellido/s del tutor",
            "OBSERVATIONS": "Observaciones",
            "RECEPIT_NUMBER": "Número de Recibo",
            "SUBJECT_NAME": "Nombre",
            "NEW_TITULO": "Titulo",
            "NEW_RESUMEN": "Resumen",
            "NEW_TEXTO": "Text",
            "NEW_TIPO": "Tipo",
            "SUBJECT_DESCRIPTION": "Descripción",
            "CURRICULUM_DESCRIPTION": "Descripción",
            "PHONE_NUMBER": "Número de teléfono",
            "POSTTITLE": "Postítulo",
            "HIRE_DATE": "Fecha de Ingreso a la Institución",
            "DATE": "Fecha",
            "AMOUNT": "Monto",
            "ATTENDANCE_DATE": "Fecha desde",
            "TEACHING_START_DATE": "Fecha de Ingreso a la Docencia",
            "OTHER_TRAININGS": "Otras Capacitaciones",
            "POST_GRADUATE_COURSE": "Posgrados",
            "MOBILE_PHONE_NUMBER": "Celular",
            "ANOTHER_CONTACT_PHONE": "Otro tel. contacto",
            "ANOTHER_PHONE_BELONGS": "¿A quién pertenece el teléfono?",
            "FILTER_USERS": "Filtrar usuarios",
            "FILTER_ORDERS": "Filtrar pedidos",
            "FILTER_STUDENTS": "Filtrar alumno",
            "FILTER_SCHOOL_SCHEDULE": "Filtrar Horario Escolar",
            "FILTER_SCHOOL_YEARS": "Año Lectivo",
            "FILTER_SUBJECTS": "Filtrar materias",
            "FILTER_NEWS": "Filtrar noticias",
            "FILTER_CURRICULUM": "Filtrar PLan de Estudio",
            "FILTER_TEACHERS": "Filtrar docentes",
            "RECORDS_PER_PAGE": "Registros por página",
            "OF": "de",
            "PREVIOUS": "Anterior",
            "NEXT": "Siguiente",
            "CHECK_ALL": "Marcar todo",
            "UNCHECK_ALL": "Desmarcar todo",
            "NAME": "Nombre",
            "DESCRIPTION": "Descripción",
            "DOCUMENT_NUMBER": "Número de documento",
            "DOCUMENT_NUMBER_ALUMNO": "Número de documento del alumno",
            "DOCUMENT_NUMBER_TUTOR": "Número de documento del tutor",
            "CUIL": "CUIL",
            "CUIL_ALUMNO": "CUIL del alumno",
            "CUIL_TUTOR": "CUIL del tutor",
            "YEAR_NAME": "Año",
            "DIVISION_NAME": "Nombre de División",
            "GENDER": "Sexo",
            "GENDER_ALUMNO": "Sexo del alumno",
            "GENDER_TUTOR": "Sexo del tutor",
            "AGE": "Edad",
            "ADDRESS": "Domicilio / Barrio",
            "BIRTHDATE": "Fecha de nacimiento",
            "BIRTHDATE_ALUMNO": "Fecha de nacimiento del alumno",
            "BIRTHDATE_TUTOR": "Fecha de nacimiento del tutor",
            "START_DATE": "Fecha de Inicio",
            "FINISH_DATE": "Fecha de Finalización",
            "START": "Inicio",
            "FINISH": "Fin",
            "TYPE_SCHOOL_SCHEDULE": "Tipo de Horario Escolar",
            "NEW_PASSWORD": "Nueva contraseña",
            "CONFIRM_NEW_PASSWORD": "Confirmar nueva contraseña",
            "PHOTO": "Foto",
            "ACTIONS": "Acciones",
            "HEIGHT": "Alto",
            "WEIGHT": "Peso",
            "STATUS": "Estado",
            "FIELD": "Este campo",
            "ORIGIN": "Origen",
            "WIDTH": "Ancho",
            "COUNT": "Cantidad",
            "COURSE_LIST": "Listado de cursos",
            "CONCEPT": "Concepto",
            "SHIFT": "Turno",
            "RELATIONSHIP": "Parentesco con el alumno",
            "MLRELATIONSHIP": "Parentesco",
            "CURRICULUM": "Plan de Estudio",
            "EVENT_TYPE": "Tipo de Evento",
            "TYPE_EMPLOYEE": "Condición Laboral",
            "COURSE": "Curso",
            "JOB_TITLE": "Cargo",
            "JOB_TITLES": "Cargos",
            "SUBJECT": "Materia",
            "FEMALE": "Femenino",
            "MALE": "Masculino",
            "HAS_BROTHERS_SCHOOL_AGE": "Tiene hermano/a MAYOR en edad escolar",
            "REPEAT_STUDENT": "Es alumno/a",
            "BELONGS_ETHNIC_GROUP": "¿Pertenece a una Étnia?",
            "BELONGS_RURAL_COMMUNITY": "¿Pertenece a una comunidad rural?",
            "ETHNIC_NAME": "Nombre de la Étnia",
            "FILE_NUMBER": "Legajo",
            "LIBRO": "Libro",
            "FOLIO": "Folio",
            "HAS_PROGRESAR_PLAN": "¿Tiene Progresar?",
            "HAS_GOVERNMENT_PC": "¿Tiene computadora del Gobierno?",
            "HAS_INTERNET": "¿Tiene Internet?",
            "RURAL_COMMUNITY": "Nombre Comnunidad Rural",
            "HAS_HEALTH_PROBLEMS": "¿Tiene problemas de salud?",
            "DESCRIPTION_HEALTH_PROBLEMS": "Describa los problemas de salud",
            "HAS_LEGAL_PROBLEMS": "¿Tiene problemas legales?",
            "DESCRIPTION_LEGAL_PROBLEMS": "Describa los problemas legales",
            "YEAR": "Año",
            "TITLE": "Título",
            "SCHOOL_NUMBER": "Número",
            "SCHOOL_NAME": "Nombre",
            "MAIL": "Correo",
            "SCHOOL_ADDRESS": "Domicilio",
            "SCHOOL_PHONE_NUMBER": "Teléfono",
            "SCHOOL_ENTRY_TIME": "Hora de ingreso",
            "SCHOOL_DEPARTURE_TIME": "Hora de salida",
            "VICE_DIRECTOR": "Vice director",
            "DIRECTOR": "Director",
            "MARGIN_TOP": "Margen Superior",
            "MARGIN_BOTTOM": "Margen Inferior",
            "MARGIN_LEFT": "Margen Izquierdo",
            "MARGIN_RIGHT": "Margen Derecho",
            "ROW_HEIGHT": "Alto de Renglón",
            "FILTER_EMPLOYEE": "Filtrar Personal",
            "SET_UP": "Configurar",
            "ATTRIBUTES": "Atributos",
            "EMAILS_LIST": "Lista de Correos",
            "PERSONAL_DATA": "Datos personales",
            "PERSONAL_DATA_CONT": "Datos personales (Cont.)",
            "HAS_PENDING_SUBJECTS": "¿Tiene materias pendientes?",
            "PENDINGS_SUJECTS": "Materias Pendientes",
            "CONTACT": "Contacto",
            "TUTOR": "Tutor",
            "TUTOR_CONT": "Tutor (Cont.)",
            "DOCUMENTATION": "Documentación",
            "PAYMENTS": "Bono Contribución",
            "ADD_PENDING_SUBJECT": "Agregar Materia Adeudada",
            "ADD_PAYMENTS": "Agregar Pago",
            "ADMISSION": "Ingreso",
            "TITLES": "Títulos",
            "WORKLOAD": "Carga Horaria",
            "HOURS": "Horas",
            "NATIONALITY": "Nacionalidad",
            "LOCATION": "Localidad",
            "OCUPATION": "Ocupación",
            "SCHOOL_ORIGIN": "Escuela de procedencia",
            "PAYMENT": "Pago",
            "EXAM_CALL_TYPE": "Tipo",
            "EXAM_CALL_DESCRIPTION": "Descripción",
            "FILTER_EXAM_CALLS": "Filtrar llamados",
            "FILTER_EXAM_BOARDS": "Filtrar mesas",
            "TIME": "Hora",
            "EXAM_BOARDS_LIST": "Listado de mesas de exámenes",
            "SUBJECTS": "Materias",
            "SELECT_EXAM_CALLS": "Seleccionar llamados",
            "MONTH": "Mes",
            "CALL_NUMBER": "Nro llamado"
        },

        "VALIDATIONS": {
            "REQUIRED": "{{value}} es requerido",
            "REQUIRED_OR_ERROR": "{{value}} es requerido o el formato es incorrecto",
            "EMAIL": "Por favor ingrese un email válido",
            "PASSWORD": "La contraseña debe contener al menos 6 caracteres, 1 letra mayúscula, 1 letra minúscula, 1 número y 1 caracter alfanumérico.",
            "PASSWORD_MIN": "La contraseña debe contener al menos 6 caracteres.",
            "PASSWORDS_MISMATCH": "Las contraseñas no coinciden"
        },
        "ERRORS": {
            "INCORRECT_USERNAME_OR_PASSWORD": "Usuario o contraseña incorrecto",
            "HTTP_STATUS_CODES": {
                "401": {
                    "MESSAGE": "Acceso restringido. Necesitas estar autenticado para realizar esta acción.",
                    "GOBACK": "Ir a iniciar sesión"
                },
                "403": {
                    "MESSAGE": "No tienes suficientes permisos para realizar esta acción.",
                    "GOBACK": "Volver al inicio"
                },
                "404": {
                    "MESSAGE": "Lo sentimos pero no pudimos encontrar la página que está buscando.",
                    "GOBACK": "Volver al inicio"
                },
                "500": {
                    "MESSAGE": "Parece que tenemos un problema interno. Inténtalo de nuevo en unos minutos.",
                    "GOBACK": "Volver al inicio"
                }
            },
            "ERROR_REQUEST": "Ocurrio un error procesando la solicutud. Detalle: {{value}}",
            "MAXIMUM_SIZE_EXCEEDED": "El tamaño máximo del archivo es {{value}}"
        },
        "BUTTONS": {
            "GOBACK": "Volver",
            "LOGIN": "Iniciar Sesión",
            "LOGOUT": "Cerrar Sesión",
            "MY_PROFILE": "Mi Perfil",
            "ADD_USER": "Agregar Usuario",
            "ADD_ORDER": "Agregar Pedido",
            "ADD_ROLE": "Agregar Rol",
            "REMOVE_ROLE": "Borrar Rol",
            "SAVE": "Guardar",
            "SAVE_AND_EXIT": "Guardar y salir",
            "SAVE_CHANGES": "Guardar Cambios",
            "CLOSE": "Cerrar",
            "CANCEL": "Cancelar",
            "VIEW": "Ver",
            "EDIT": "Editar",
            "DELETE": "Eliminar",
            "CHANGE_COURSE": "Cambiar de turno",
            "MEDICAL_LETTER_REQUEST": "Solicitud de Carta Médica",
            "CHANGE_PASSWORD": "Cambiar contraseña",
            "ADD_STUDENT": "Agregar alumno",
            "ADD_EMPLOYEE": "Agregar personal",
            "ADD_SUBJECT": "Agregar materia",
            "NEW_TITLE": "Titulo",
            "NEW_RESUMEN": "Resumen",
            "ADD_NEWS": "Agregar noticia",
            "EDIT_NEWS": "Edita noticia",
            "VIEW_NEWS": "Ver Noticia",
            "ADD_YEAR": "Agregar Año",
            "ADD_CURRICULUM": "Agregar Plan de Estudios",
            "ADD_DIVISION": "Agregar División",
            "ADD_SCHOOL_SCHEDULE": "Agregar Horario Escolar",
            "ADD_SCHOOL_YEAR": "Agregar Ciclo Lectivo",
            "ADD_SCHEDULE": "Agregar Horario",
            "PRINT_STUDENTLIST": "Listado de alumnos",
            "PRINT": "Imprimir",
            "PRINT_ALL": "Imprimir Todos",
            "PRINT_REPORTCARD": "Planilla de Calificaciones",
            "ADD_TEACHER": "Agregar docente",
            "ADD_TUTOR": "Agregar tutor",
            "EDIT_STUDENT": "Editar alumno",
            "EDIT_EMPLOYE": "Editar personal",
            "EDIT_SUBJECT": "Editar materia",
            "EDIT_DIVISION": "Editar División",
            "EDIT_SCHOOL_SCHEDULE": "Editar Horario Escolar",
            "EDIT_TEACHER": "Editar docente",
            "ASSIGN_TEACHER": "Asignar docente",
            "EDIT_TUTOR": "Editar tutor",
            "EDIT_YEAR": "Editar Año",
            "VIEW_STUDENT": "Ver alumno",
            "VIEW_EMPLOYEE": "Ver personal",
            "VIEW_SUBJECT": "Ver materia",
            "VIEW_TEACHER": "Ver docente",
            "VIEW_SCHOOL_SCHEDULE": "Ver Horario Escolar",
            "VIEW_TUTOR": "Ver tutor",
            "VIEW_DIVISION": "Ver Division",
            "VIEW_YEAR": "Ver Año",
            "DETAIL": "Detalle",
            "ADD": "Agregar",
            "ACCEPT": "Aceptar",
            "REFRESH": "Refrescar",
            "INDEX_CARD_CONFIGURATION": "Configuración de Fichero. (Todos los valores son en mm.)",
            "TEACHING_ASSISTANCE": "Asistencia Docente",
            "PRINT_INDEX_CARD": "Imprimir Fichas",
            "EXPORT_TO_EXCEL": "Exportar a Excel",
            "RECEIPTS_TO_EXCEL": "Exportar Recibos",
            "EMAILS": "Correos",
            "EXPORT": "Exportar",
            "CONSULT": "Consultar",
            "COPY": "Copiar",
            "ADD_JOB_TITLE": "Agregar Cargo",
            "BONUS": "Bono",
            "ADD_PAYMENT": "Agregar pago",
            "VIEW_HISTORY": "Ver historial",
            "ADD_NEW": "Agregar Noticias",
            "ADD_EXAM_CALL": "Agregar llamado",
            "ADD_EXAM_BOARD": "Agregar mesa",
            "DOWNLOAD": "Descargar"
        },

        "TABLES": {
            "NOFOUND": "No se encontraron registros que coincidan con el filtro"
        },
        "LANGUAGES": {
            "ENGLISH": "Inglés",
            "SPANISH": "Español",
        },

        "PERMISSIONS": {
            "PAGES_HOME": "Inicio",
            "PAGES_MANAGEMENT": "Administración",
            "PAGES_MANAGEMENT_USERS": "Administración > Usuarios",
            "PAGES_MANAGEMENT_USERS_ADD": "Administración > Usuarios > Agregar",
            "PAGES_MANAGEMENT_USERS_EDIT": "Administración > Usuarios > Editar",
            "PAGES_MANAGEMENT_USERS_REMOVE": "Administración > Usuarios > Borrar",
            "PAGES_MANAGEMENT_USERS_VIEW": "Administración > Usuarios > Ver",
            "PAGES_MANAGEMENT_USERS_CHANGEPASSWORD": "Administración > Usuarios > Cambiar Contraseña",

            "PAGES_MANAGEMENT_STUDENTS": "Administración > Alumnos",
            "PAGES_MANAGEMENT_STUDENTS_ADD": "Administración > Alumnos > Agregar",
            "PAGES_MANAGEMENT_STUDENTS_EDIT": "Administración > Alumnos > Editar",
            "PAGES_MANAGEMENT_STUDENTS_REMOVE": "Administración > Alumnos > Borrar",
            "PAGES_MANAGEMENT_STUDENTS_DETAIL": "Administración > Alumnos > Detalle",
            "PAGES_MANAGEMENT_STUDENTS_EXPORT": "Administración > Alumnos > Exportar a Excel",
            "PAGES_MANAGEMENT_STUDENTS_EXPORT_RECEIPTS": "Administración > Alumnos > Exportar Recibos a Excel",
            "PAGES_MANAGEMENT_STUDENTS_CHANGE_COURSE": "Administración > Alumnos > Cambiar de Curso",
            "PAGES_MANAGEMENT_STUDENTS_VIEW_PAYMENT": "Administración > Alumnos > Ver detalle de Bono Contribución",

            "PAGES_MANAGEMENT_TEACHERS": "Administración > Docentes",
            "PAGES_MANAGEMENT_TEACHERS_ADD": "Administración > Docentes > Agregar",
            "PAGES_MANAGEMENT_TEACHERS_EDIT": "Administración > Docentes > Editar",
            "PAGES_MANAGEMENT_TEACHERS_REMOVE": "Administración > Docentes > Borrar",
            "PAGES_MANAGEMENT_TEACHERS_DETAIL": "Administración > Docentes > Detalle",

            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE": "Administración > Horario Escolar",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_ADD": "Administración > Horario Escolar > Agregar",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_EDIT": "Administración > Horario Escolar > Editar",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_REMOVE": "Administración > Horario Escolar > Borrar",
            "PAGES_MANAGEMENT_SCHOOL_SCHEDULE_DETAIL": "Administración > Horario Escolar > Detalle",

            "PAGES_MANAGEMENT_SCHOOLDATA": "Administración > Datos del colegio",
            "PAGES_MANAGEMENT_SCHOOLDATA_EDIT": "Administración > Datos del colegio > Editar",

            "PAGES_MANAGEMENT_SCHOOL_YEAR": "Administración > Año Lectivo",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_ADD": "Administración > Año Lectivo > Agregar",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_EDIT": "Administración > Año Lectivo > Editar",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_DELETE": "Administración > Año Lectivo > Borrar",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_DETAIL": "Administración > Año Lectivo > Detalle",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_ACTIVE": "Administración > Año Lectivo > Activar nuevo Año",

            "PAGES_MANAGEMENT_EMPLOYEE": "Administración > Personal",
            "PAGES_MANAGEMENT_EMPLOYEE_ADD": "Administración > Personal > Agregar",
            "PAGES_MANAGEMENT_EMPLOYEE_EDIT": "Administración > Personal > Editar",
            "PAGES_MANAGEMENT_EMPLOYEE_DELETE": "Administración > Personal > Borrar",
            "PAGES_MANAGEMENT_EMPLOYEE_DETAIL": "Administración > Personal > Detalle",
            "PAGES_MANAGEMENT_EMPLOYEE_EXPORT_EXCEL": "Administración > Personal > Exportar",
            "PAGES_MANAGEMENT_EMPLOYEE_MEDICAL_LETTER": "Administración > Personal > Carta Médica",
            "PAGES_MANAGEMENT_EMPLOYEE_PRINT_FILES": "Administración > Personal > Imprimir Ficha",
            "PAGES_MANAGEMENT_EMPLOYEE_COPY_MAILS": "Administración > Personal > Copiar Mail",
            "PAGES_MANAGEMENT_EMPLOYEE_PRINT_ASSISTANCE": "Administración > Personal > Asistencia Docente",
            "PAGES_MANAGEMENT_STUDENTS_PRINT_ALUMNOS": "Administración > Alumnos > Imprimir Listado de Alumnos",
            "PAGES_MANAGEMENT_STUDENTS_PRINT_CALIFICACIONES": "Administración > Alumnos > Imprimir Planilla de Calificaciones",
            "PAGES_MANAGEMENT_NEWS": "Administración > Noticias",
            "PAGES_NEWS": "Noticias",
            "PAGES_MANAGEMENT_NEWS_ADD": "Administración > Noticias > Agregar",
            "PAGES_MANAGEMENT_NEWS_DETAIL": "Administración > Noticias > Ver",
            "PAGES_MANAGEMENT_NEWS_EDIT": "Administración > Noticias > Editar",
            "PAGES_MANAGEMENT_NEWS_REMOVE": "Administración > Noticias > Eliminar",

            "PAGES_MANAGEMENT_CURRICULUM": "Administración > Planes de estudio",
            "PAGES_MANAGEMENT_CURRICULUM_ADD": "Administración > Planes de estudio > Agregar",
            "PAGES_MANAGEMENT_CURRICULUM_EDIT": "Administración > Planes de estudio > Editar",
            "PAGES_MANAGEMENT_CURRICULUM_REMOVE": "Administración > Planes de estudio > Borrar",
            "PAGES_MANAGEMENT_CURRICULUM_VIEW": "Administración > Planes de estudio > Detalle",

            "PAGES_MANAGEMENT_SUBJECTS": "Administración > Materias",
            "PAGES_MANAGEMENT_SUBJECTS_ADD": "Administración > Materias > Agregar",
            "PAGES_MANAGEMENT_SUBJECTS_EDIT": "Administración > Materias > Editar",
            "PAGES_MANAGEMENT_SUBJECTS_REMOVE": "Administración > Materias > Borrar",
            "PAGES_MANAGEMENT_SUBJECTS_DETAIL": "Administración > Materias > Detalle",

            "PAGES_MANAGEMENT_DIVISIONS": "Administración > Divisiones",
            "PAGES_MANAGEMENT_DIVISIONS_ADD": "Administración > Divisiones > Agregar",
            "PAGES_MANAGEMENT_DIVISIONS_EDIT": "Administración > Divisiones > Editar",
            "PAGES_MANAGEMENT_DIVISIONS_REMOVE": "Administración > Divisiones > Borrar",
            "PAGES_MANAGEMENT_DIVISIONS_DETAIL": "Administración > Divisiones > Detalle",

            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT": "Administración > Concepto docente",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT_EDIT": "Administración > Concepto docente > Editar",
            "PAGES_MANAGEMENT_SCHOOL_YEAR_CONCEPT_DETAIL": "Administración > Concepto docente > Detalle",

            "PAGES_SECURITY": "Seguridad",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS": "Seguridad > Roles y Permisos",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_ADD": "Seguridad > Roles y Permisos > Agregar",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_EDIT": "Seguridad > Roles y Permisos > Editar",
            "PAGES_SECURITY_ROLES_AND_PERMISSIONS_REMOVE": "Seguridad > Roles y Permisos > Borrar",

            "PAGES_MANAGEMENT_EMPLOYEES": "Administración > Empleados",
            "PAGES_MANAGEMENT_EMPLOYEES_ADD": "Administración > Empleados > Agregar",
            "PAGES_MANAGEMENT_EMPLOYEES_EDIT": "Administración > Empleados > Editar",
            "PAGES_MANAGEMENT_EMPLOYEES_REMOVE": "Administración > Empleados > Eliminar",
            "PAGES_MANAGEMENT_EMPLOYEES_DETAIL": "Administración > Empleados > Detalle",
            "PAGES_MANAGEMENT_EMPLOYEES_EXPORT": "Administración > Empleados > Exportar",
            "PAGES_MANAGEMENT_ACTOS": "Administración > Actos"
        },
        "MESSAGES": {
            "REPORT_CONFIG_DESCRIPTION": "Configure cómo desea que se visualicen los nombres de las personas en los reportes PDF generados por el sistema (Asistencia Docente, Calificaciones y Mesas de Exámenes)."
        },
        "LABELS": {
            "SUCCESS": "Éxito",
            "REPORT_CONFIGURATION": "Configuración de Reportes",
            "PDF_REPORTS_SETTINGS": "Ajustes de Reportes PDF",
            "USE_ALIAS_IN_REPORTS": "Utilizar Alias en los reportes",
            "DELETION_CONFIRMATION_QUESTION": "¿Esta seguro que quiere borrar \"{{value}}\"?",
            "YES": "Sí",
            "NO": "No",
            "PROMOTED_REPEATER_REENROLLED": "Promovido / Repitente / Reinscripto ",
            "REENROLLED": "Reinscripto",
            "REPEATER": "Repitente",
            "PROMOTED": "Promovido",
            "CONFIRMATION": "Confirmación",
            "DELETED_CORRECTLY": "Elemento borrado correctamente",
            "SUCCESS_REQUEST": "Solicitud procesada correctamente",
            "CHANGES_SAVED_CORRECTLY": "Cambios guardados correctamente",
            "SAVING_CHANGES": "Guardando cambios...",
            "CORRECTLY_ADDED": "{{value}} agregado correctamente",
            "CORRECTLY_MODIFIED": "{{value}} modificado correctamente",
            "CORRECTLY_MODIFIED_FEMALE": "{{value}} modificada correctamente",
            "CORRECTLY_DELETED": "{{value}} borrado correctamente",
            "CORRECTLY_UPLOADED": "{{value}} subido correctamente",
            "CORRECTLY_UPLOADED_FEMALE": "{{value}} subida correctamente",
            "ROLE": "Rol",
            "USER": "Usuario",
            "PERMISSION": "Permiso",
            "LOADING": "Cargando...",
            "LOADING_VALUE": "Cargando {{value}}...",
            "SEARCH": "Buscar",
            "STUDENT": "Alumno",
            "TEACHER": "Docente",
            "PERSON": "Personal",
            "MEDICALLETTER": "Carta Médica",
            "VIEW_MEDICALLETTER": "Ver Carta Médica de ",
            "ADD_MEDICALLETTER": "Agregar Carta Médica para ",
            "EDIT_MEDICALLETTER": "Editar Carta Médica de ",
            "PRINT_LIST_OF": "Planilla de",
            "PRINT_LIST_REPORT_STUDENT": "Planilla de",
            "PRINT_CARD": "Calificaciones",
            "PRINT_STUDENTS": "Alumnos",
            "EDIT_DIVISION": "Editar",
            "DELETE_DIVISION": "Borrar",
            "DIVISION_SCHEDULE": "Horario",
            "DIVISION_SCHEDULE_ALL": "Imprimir todos los horarios",
            "TEACHER_ALL": "Descargar Listado de Docentes",
            "DIVISION_TEACHERS": "Profesores",
            "HEADER_CURRICULUM": "Datos del Plan de Estudios",
            "HEADER_SCHOOL_YEAR": "Datos del Ciclo Lectivo",
            "PROFESSIONAL_CONCEPT": "Concepto Docente",
            "DIVISIONS_BY_SHIFT": "Divisiones por Turno",
            "Staff": "Personal",
            "SUBJECTS_BY_YEAR": "Materias por Año",
            "YEAR": "Año",
            "DIVISION": "División",
            "STUDENTS": "Estudiantes",
            "HEADER_SCHOOL_DATA": "Datos del establecimiento",
            "SHIFTS": "Turno",
            "NEW": "Noticia",
            "MENU": "Menú",
            "DATA_SAVED_CORRECTLY": "Datos guardados correctamente",
            "MANUALLY_DATA": "Carga manual",
            "COURSES": "Cursos",
            "PAYMENT": "Ingresos",
            "TOTAL_AMOUNT": "Total(seleccionado)",
            "HISTORY": "Historial de inscripciones"
        },
        "EXAM_CALL_TYPES": {
            "REGULAR": "REGULARES Y PARA ADELANTAR AÑO",
            "COMPLETE": "COMPLETAR CARRERA",
            "PENDING": "PENDIENTES, EQUIVALENCIAS, LIBRES Y COMPLETAR CARRERA"
        },
        "MONTHS": {
            "JANUARY": "Enero",
            "FEBRUARY": "Febrero",
            "MARCH": "Marzo",
            "APRIL": "Abril",
            "MAY": "Mayo",
            "JUNE": "Junio",
            "JULY": "Julio",
            "AUGUST": "Agosto",
            "SEPTEMBER": "Septiembre",
            "OCTOBER": "Octubre",
            "NOVEMBER": "Noviembre",
            "DECEMBER": "Diciembre"
        },
        "CALL_NUMBERS": {
            "FIRST": "Primer llamado",
            "SECOND": "Segundo llamado",
            "THIRD": "Tercer llamado",
            "FOURTH": "Cuarto llamado",
            "FIFTH": "Quinto llamado",
            "SIXTH": "Sexto llamado",
            "SEVENTH": "Séptimo llamado",
            "EIGHTH": "Octavo llamado",
            "NINTH": "Noveno llamado",
            "TENTH": "Décimo llamado"
        }

    }
};



// WEBPACK FOOTER //
// ./src/app/main/i18n/es.ts